<template>
  <b-button
    v-if="elementVisible"
    icon-right="history"
    class="local-lm-btn-row"
    @click.prevent="callActions(supplierOrderID, modalActions)"
  />
</template>

<script>
export default {
  name: 'BtnRestoreOrder',
  props: {
    actions: Object
  },
  computed: {
    supplierOrderID () {
      return this.$attrs.id
    },
    supplierOrderCode () {
      return this.$attrs.supplierOrderCode
    },
    modalActions () {
      return this.$props.actions
    },
    timeToLeft () {
      const add1h = 1000 * 60 * 60 // one hour
      const inicio = new Date(this.$attrs.supplierCollectionRequestDate)
      const more1h = new Date(inicio.getTime() + add1h)
      const now = new Date(Date.now())
      const diff = more1h - now

      return diff
    }
  },
  data () {
    return {
      elementVisible: true
    }
  },
  mounted () {
    setTimeout(function () {
      this.$eventBus.$emit('removeRestoreControl', this.$attrs.supplierOrderCode)
      this.elementVisible = false
    }.bind(this), this.timeToLeft)
  },
  methods: {
    callActions (order, type) {
      const orders = [{
        id: order,
        supplierOrderCode: parseInt(this.supplierOrderCode)
      }]

      const data = {
        orders,
        type
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/BtnRestoreOrder.vue